import React from "react";
import { Typography } from "@mui/material";

export const Title = ({ title }: { title: string }): React.ReactElement => (
  <Typography variant="h6" noWrap>
    {title}
  </Typography>
);
